// source: internal/proto/goveeenergymonitoring.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.proto.AggregateStatisticsRequest', null, global);
goog.exportSymbol('proto.proto.AggregateStatisticsResponse', null, global);
goog.exportSymbol('proto.proto.BucketedSamples', null, global);
goog.exportSymbol('proto.proto.DisplayNameRequest', null, global);
goog.exportSymbol('proto.proto.DisplayNameResponse', null, global);
goog.exportSymbol('proto.proto.ListSmartPlugsRequest', null, global);
goog.exportSymbol('proto.proto.ListSmartPlugsResponse', null, global);
goog.exportSymbol('proto.proto.RegisterSmartPlugRequest', null, global);
goog.exportSymbol('proto.proto.Sample', null, global);
goog.exportSymbol('proto.proto.SampleSummary', null, global);
goog.exportSymbol('proto.proto.SeriesMetadata', null, global);
goog.exportSymbol('proto.proto.SmartPlug', null, global);
goog.exportSymbol('proto.proto.SmartPlugSignalEntry', null, global);
goog.exportSymbol('proto.proto.SummarySample', null, global);
goog.exportSymbol('proto.proto.SummaryStatistics', null, global);
goog.exportSymbol('proto.proto.SummaryStatisticsRequest', null, global);
goog.exportSymbol('proto.proto.SummaryStatisticsResponse', null, global);
goog.exportSymbol('proto.proto.TimeRange', null, global);
goog.exportSymbol('proto.proto.TimeSeriesRequest', null, global);
goog.exportSymbol('proto.proto.TimeSeriesResponse', null, global);
goog.exportSymbol('proto.proto.Trend', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.RegisterSmartPlugRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.RegisterSmartPlugRequest.repeatedFields_, null);
};
goog.inherits(proto.proto.RegisterSmartPlugRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.RegisterSmartPlugRequest.displayName = 'proto.proto.RegisterSmartPlugRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.SmartPlugSignalEntry = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.SmartPlugSignalEntry, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.SmartPlugSignalEntry.displayName = 'proto.proto.SmartPlugSignalEntry';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.SmartPlug = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.SmartPlug.repeatedFields_, null);
};
goog.inherits(proto.proto.SmartPlug, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.SmartPlug.displayName = 'proto.proto.SmartPlug';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Sample = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Sample, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Sample.displayName = 'proto.proto.Sample';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.SampleSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.SampleSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.SampleSummary.displayName = 'proto.proto.SampleSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.ListSmartPlugsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.ListSmartPlugsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.ListSmartPlugsRequest.displayName = 'proto.proto.ListSmartPlugsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.TimeRange = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.TimeRange, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.TimeRange.displayName = 'proto.proto.TimeRange';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.ListSmartPlugsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.ListSmartPlugsResponse.repeatedFields_, null);
};
goog.inherits(proto.proto.ListSmartPlugsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.ListSmartPlugsResponse.displayName = 'proto.proto.ListSmartPlugsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.TimeSeriesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.TimeSeriesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.TimeSeriesRequest.displayName = 'proto.proto.TimeSeriesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.SeriesMetadata = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.SeriesMetadata, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.SeriesMetadata.displayName = 'proto.proto.SeriesMetadata';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.TimeSeriesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.TimeSeriesResponse.repeatedFields_, null);
};
goog.inherits(proto.proto.TimeSeriesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.TimeSeriesResponse.displayName = 'proto.proto.TimeSeriesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.BucketedSamples = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.BucketedSamples, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.BucketedSamples.displayName = 'proto.proto.BucketedSamples';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.DisplayNameRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.DisplayNameRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.DisplayNameRequest.displayName = 'proto.proto.DisplayNameRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.DisplayNameResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.DisplayNameResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.DisplayNameResponse.displayName = 'proto.proto.DisplayNameResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.SummaryStatisticsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.SummaryStatisticsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.SummaryStatisticsRequest.displayName = 'proto.proto.SummaryStatisticsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.SummaryStatisticsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.SummaryStatisticsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.SummaryStatisticsResponse.displayName = 'proto.proto.SummaryStatisticsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.SummaryStatistics = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.SummaryStatistics.repeatedFields_, null);
};
goog.inherits(proto.proto.SummaryStatistics, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.SummaryStatistics.displayName = 'proto.proto.SummaryStatistics';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Trend = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Trend, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Trend.displayName = 'proto.proto.Trend';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.SummarySample = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.SummarySample, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.SummarySample.displayName = 'proto.proto.SummarySample';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.AggregateStatisticsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.AggregateStatisticsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.AggregateStatisticsRequest.displayName = 'proto.proto.AggregateStatisticsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.AggregateStatisticsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.AggregateStatisticsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.AggregateStatisticsResponse.displayName = 'proto.proto.AggregateStatisticsResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.RegisterSmartPlugRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.RegisterSmartPlugRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.RegisterSmartPlugRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.RegisterSmartPlugRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RegisterSmartPlugRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
manufacturerId: jspb.Message.getFieldWithDefault(msg, 2, ""),
addressesList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
signalStrength: jspb.Message.getFieldWithDefault(msg, 4, 0),
clientHostname: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.RegisterSmartPlugRequest}
 */
proto.proto.RegisterSmartPlugRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.RegisterSmartPlugRequest;
  return proto.proto.RegisterSmartPlugRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.RegisterSmartPlugRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.RegisterSmartPlugRequest}
 */
proto.proto.RegisterSmartPlugRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setManufacturerId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addAddresses(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setSignalStrength(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientHostname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.RegisterSmartPlugRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.RegisterSmartPlugRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.RegisterSmartPlugRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.RegisterSmartPlugRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getManufacturerId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAddressesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getSignalStrength();
  if (f !== 0) {
    writer.writeSint32(
      4,
      f
    );
  }
  f = message.getClientHostname();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.proto.RegisterSmartPlugRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.RegisterSmartPlugRequest} returns this
 */
proto.proto.RegisterSmartPlugRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string manufacturer_id = 2;
 * @return {string}
 */
proto.proto.RegisterSmartPlugRequest.prototype.getManufacturerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.RegisterSmartPlugRequest} returns this
 */
proto.proto.RegisterSmartPlugRequest.prototype.setManufacturerId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string addresses = 3;
 * @return {!Array<string>}
 */
proto.proto.RegisterSmartPlugRequest.prototype.getAddressesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.proto.RegisterSmartPlugRequest} returns this
 */
proto.proto.RegisterSmartPlugRequest.prototype.setAddressesList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.proto.RegisterSmartPlugRequest} returns this
 */
proto.proto.RegisterSmartPlugRequest.prototype.addAddresses = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.RegisterSmartPlugRequest} returns this
 */
proto.proto.RegisterSmartPlugRequest.prototype.clearAddressesList = function() {
  return this.setAddressesList([]);
};


/**
 * optional sint32 signal_strength = 4;
 * @return {number}
 */
proto.proto.RegisterSmartPlugRequest.prototype.getSignalStrength = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.RegisterSmartPlugRequest} returns this
 */
proto.proto.RegisterSmartPlugRequest.prototype.setSignalStrength = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string client_hostname = 5;
 * @return {string}
 */
proto.proto.RegisterSmartPlugRequest.prototype.getClientHostname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.RegisterSmartPlugRequest} returns this
 */
proto.proto.RegisterSmartPlugRequest.prototype.setClientHostname = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.SmartPlugSignalEntry.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.SmartPlugSignalEntry.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.SmartPlugSignalEntry} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.SmartPlugSignalEntry.toObject = function(includeInstance, msg) {
  var f, obj = {
clientHostname: jspb.Message.getFieldWithDefault(msg, 1, ""),
lastUpdated: jspb.Message.getFieldWithDefault(msg, 2, 0),
signalStrength: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.SmartPlugSignalEntry}
 */
proto.proto.SmartPlugSignalEntry.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.SmartPlugSignalEntry;
  return proto.proto.SmartPlugSignalEntry.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.SmartPlugSignalEntry} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.SmartPlugSignalEntry}
 */
proto.proto.SmartPlugSignalEntry.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientHostname(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLastUpdated(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setSignalStrength(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.SmartPlugSignalEntry.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.SmartPlugSignalEntry.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.SmartPlugSignalEntry} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.SmartPlugSignalEntry.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClientHostname();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLastUpdated();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getSignalStrength();
  if (f !== 0) {
    writer.writeSint32(
      3,
      f
    );
  }
};


/**
 * optional string client_hostname = 1;
 * @return {string}
 */
proto.proto.SmartPlugSignalEntry.prototype.getClientHostname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.SmartPlugSignalEntry} returns this
 */
proto.proto.SmartPlugSignalEntry.prototype.setClientHostname = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 last_updated = 2;
 * @return {number}
 */
proto.proto.SmartPlugSignalEntry.prototype.getLastUpdated = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.SmartPlugSignalEntry} returns this
 */
proto.proto.SmartPlugSignalEntry.prototype.setLastUpdated = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional sint32 signal_strength = 3;
 * @return {number}
 */
proto.proto.SmartPlugSignalEntry.prototype.getSignalStrength = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.SmartPlugSignalEntry} returns this
 */
proto.proto.SmartPlugSignalEntry.prototype.setSignalStrength = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.SmartPlug.repeatedFields_ = [3,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.SmartPlug.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.SmartPlug.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.SmartPlug} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.SmartPlug.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
addressesList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
manufacturerId: jspb.Message.getFieldWithDefault(msg, 2, ""),
displayName: jspb.Message.getFieldWithDefault(msg, 4, ""),
bestSignalStrength: jspb.Message.getFieldWithDefault(msg, 6, 0),
signalsList: jspb.Message.toObjectList(msg.getSignalsList(),
    proto.proto.SmartPlugSignalEntry.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.SmartPlug}
 */
proto.proto.SmartPlug.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.SmartPlug;
  return proto.proto.SmartPlug.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.SmartPlug} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.SmartPlug}
 */
proto.proto.SmartPlug.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addAddresses(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setManufacturerId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setBestSignalStrength(value);
      break;
    case 7:
      var value = new proto.proto.SmartPlugSignalEntry;
      reader.readMessage(value,proto.proto.SmartPlugSignalEntry.deserializeBinaryFromReader);
      msg.addSignals(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.SmartPlug.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.SmartPlug.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.SmartPlug} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.SmartPlug.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAddressesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getManufacturerId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getBestSignalStrength();
  if (f !== 0) {
    writer.writeSint32(
      6,
      f
    );
  }
  f = message.getSignalsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.proto.SmartPlugSignalEntry.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.proto.SmartPlug.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.SmartPlug} returns this
 */
proto.proto.SmartPlug.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string addresses = 3;
 * @return {!Array<string>}
 */
proto.proto.SmartPlug.prototype.getAddressesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.proto.SmartPlug} returns this
 */
proto.proto.SmartPlug.prototype.setAddressesList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.proto.SmartPlug} returns this
 */
proto.proto.SmartPlug.prototype.addAddresses = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.SmartPlug} returns this
 */
proto.proto.SmartPlug.prototype.clearAddressesList = function() {
  return this.setAddressesList([]);
};


/**
 * optional string manufacturer_id = 2;
 * @return {string}
 */
proto.proto.SmartPlug.prototype.getManufacturerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.SmartPlug} returns this
 */
proto.proto.SmartPlug.prototype.setManufacturerId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string display_name = 4;
 * @return {string}
 */
proto.proto.SmartPlug.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.SmartPlug} returns this
 */
proto.proto.SmartPlug.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional sint32 best_signal_strength = 6;
 * @return {number}
 */
proto.proto.SmartPlug.prototype.getBestSignalStrength = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.SmartPlug} returns this
 */
proto.proto.SmartPlug.prototype.setBestSignalStrength = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * repeated SmartPlugSignalEntry signals = 7;
 * @return {!Array<!proto.proto.SmartPlugSignalEntry>}
 */
proto.proto.SmartPlug.prototype.getSignalsList = function() {
  return /** @type{!Array<!proto.proto.SmartPlugSignalEntry>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.SmartPlugSignalEntry, 7));
};


/**
 * @param {!Array<!proto.proto.SmartPlugSignalEntry>} value
 * @return {!proto.proto.SmartPlug} returns this
*/
proto.proto.SmartPlug.prototype.setSignalsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.proto.SmartPlugSignalEntry=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.SmartPlugSignalEntry}
 */
proto.proto.SmartPlug.prototype.addSignals = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.proto.SmartPlugSignalEntry, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.SmartPlug} returns this
 */
proto.proto.SmartPlug.prototype.clearSignalsList = function() {
  return this.setSignalsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Sample.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Sample.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Sample} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Sample.toObject = function(includeInstance, msg) {
  var f, obj = {
smartPlugId: jspb.Message.getFieldWithDefault(msg, 1, ""),
time: jspb.Message.getFieldWithDefault(msg, 2, 0),
timePoweredOnSeconds: jspb.Message.getFieldWithDefault(msg, 3, 0),
accumulatedPowerDeciWatts: jspb.Message.getFieldWithDefault(msg, 4, 0),
centiVolts: jspb.Message.getFieldWithDefault(msg, 5, 0),
centiAmps: jspb.Message.getFieldWithDefault(msg, 6, 0),
centiWatts: jspb.Message.getFieldWithDefault(msg, 7, 0),
powerFactorPercent: jspb.Message.getFieldWithDefault(msg, 8, 0),
signalStrength: jspb.Message.getFieldWithDefault(msg, 9, 0),
checksum: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Sample}
 */
proto.proto.Sample.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Sample;
  return proto.proto.Sample.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Sample} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Sample}
 */
proto.proto.Sample.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSmartPlugId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTime(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTimePoweredOnSeconds(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAccumulatedPowerDeciWatts(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCentiVolts(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCentiAmps(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCentiWatts(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPowerFactorPercent(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setSignalStrength(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setChecksum(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Sample.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Sample.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Sample} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Sample.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSmartPlugId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTime();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getTimePoweredOnSeconds();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getAccumulatedPowerDeciWatts();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getCentiVolts();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getCentiAmps();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getCentiWatts();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
  f = message.getPowerFactorPercent();
  if (f !== 0) {
    writer.writeUint32(
      8,
      f
    );
  }
  f = message.getSignalStrength();
  if (f !== 0) {
    writer.writeSint32(
      9,
      f
    );
  }
  f = message.getChecksum();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};


/**
 * optional string smart_plug_id = 1;
 * @return {string}
 */
proto.proto.Sample.prototype.getSmartPlugId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Sample} returns this
 */
proto.proto.Sample.prototype.setSmartPlugId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 time = 2;
 * @return {number}
 */
proto.proto.Sample.prototype.getTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Sample} returns this
 */
proto.proto.Sample.prototype.setTime = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 time_powered_on_seconds = 3;
 * @return {number}
 */
proto.proto.Sample.prototype.getTimePoweredOnSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Sample} returns this
 */
proto.proto.Sample.prototype.setTimePoweredOnSeconds = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 accumulated_power_deci_watts = 4;
 * @return {number}
 */
proto.proto.Sample.prototype.getAccumulatedPowerDeciWatts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Sample} returns this
 */
proto.proto.Sample.prototype.setAccumulatedPowerDeciWatts = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint32 centi_volts = 5;
 * @return {number}
 */
proto.proto.Sample.prototype.getCentiVolts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Sample} returns this
 */
proto.proto.Sample.prototype.setCentiVolts = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional uint32 centi_amps = 6;
 * @return {number}
 */
proto.proto.Sample.prototype.getCentiAmps = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Sample} returns this
 */
proto.proto.Sample.prototype.setCentiAmps = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional uint32 centi_watts = 7;
 * @return {number}
 */
proto.proto.Sample.prototype.getCentiWatts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Sample} returns this
 */
proto.proto.Sample.prototype.setCentiWatts = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional uint32 power_factor_percent = 8;
 * @return {number}
 */
proto.proto.Sample.prototype.getPowerFactorPercent = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Sample} returns this
 */
proto.proto.Sample.prototype.setPowerFactorPercent = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional sint32 signal_strength = 9;
 * @return {number}
 */
proto.proto.Sample.prototype.getSignalStrength = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Sample} returns this
 */
proto.proto.Sample.prototype.setSignalStrength = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional string checksum = 10;
 * @return {string}
 */
proto.proto.Sample.prototype.getChecksum = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Sample} returns this
 */
proto.proto.Sample.prototype.setChecksum = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.SampleSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.SampleSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.SampleSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.SampleSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
sampleCount: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.SampleSummary}
 */
proto.proto.SampleSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.SampleSummary;
  return proto.proto.SampleSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.SampleSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.SampleSummary}
 */
proto.proto.SampleSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSampleCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.SampleSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.SampleSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.SampleSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.SampleSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSampleCount();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 sample_count = 1;
 * @return {number}
 */
proto.proto.SampleSummary.prototype.getSampleCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.SampleSummary} returns this
 */
proto.proto.SampleSummary.prototype.setSampleCount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.ListSmartPlugsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.ListSmartPlugsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.ListSmartPlugsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ListSmartPlugsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
timerange: (f = msg.getTimerange()) && proto.proto.TimeRange.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.ListSmartPlugsRequest}
 */
proto.proto.ListSmartPlugsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.ListSmartPlugsRequest;
  return proto.proto.ListSmartPlugsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.ListSmartPlugsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.ListSmartPlugsRequest}
 */
proto.proto.ListSmartPlugsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.TimeRange;
      reader.readMessage(value,proto.proto.TimeRange.deserializeBinaryFromReader);
      msg.setTimerange(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.ListSmartPlugsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.ListSmartPlugsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.ListSmartPlugsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ListSmartPlugsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimerange();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.proto.TimeRange.serializeBinaryToWriter
    );
  }
};


/**
 * optional TimeRange timeRange = 1;
 * @return {?proto.proto.TimeRange}
 */
proto.proto.ListSmartPlugsRequest.prototype.getTimerange = function() {
  return /** @type{?proto.proto.TimeRange} */ (
    jspb.Message.getWrapperField(this, proto.proto.TimeRange, 1));
};


/**
 * @param {?proto.proto.TimeRange|undefined} value
 * @return {!proto.proto.ListSmartPlugsRequest} returns this
*/
proto.proto.ListSmartPlugsRequest.prototype.setTimerange = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.ListSmartPlugsRequest} returns this
 */
proto.proto.ListSmartPlugsRequest.prototype.clearTimerange = function() {
  return this.setTimerange(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ListSmartPlugsRequest.prototype.hasTimerange = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.TimeRange.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.TimeRange.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.TimeRange} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.TimeRange.toObject = function(includeInstance, msg) {
  var f, obj = {
since: jspb.Message.getFieldWithDefault(msg, 1, 0),
until: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.TimeRange}
 */
proto.proto.TimeRange.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.TimeRange;
  return proto.proto.TimeRange.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.TimeRange} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.TimeRange}
 */
proto.proto.TimeRange.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSince(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUntil(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.TimeRange.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.TimeRange.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.TimeRange} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.TimeRange.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSince();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getUntil();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional int64 since = 1;
 * @return {number}
 */
proto.proto.TimeRange.prototype.getSince = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.TimeRange} returns this
 */
proto.proto.TimeRange.prototype.setSince = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 until = 2;
 * @return {number}
 */
proto.proto.TimeRange.prototype.getUntil = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.TimeRange} returns this
 */
proto.proto.TimeRange.prototype.setUntil = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.ListSmartPlugsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.ListSmartPlugsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.ListSmartPlugsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.ListSmartPlugsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ListSmartPlugsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
smartPlugsList: jspb.Message.toObjectList(msg.getSmartPlugsList(),
    proto.proto.SmartPlug.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.ListSmartPlugsResponse}
 */
proto.proto.ListSmartPlugsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.ListSmartPlugsResponse;
  return proto.proto.ListSmartPlugsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.ListSmartPlugsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.ListSmartPlugsResponse}
 */
proto.proto.ListSmartPlugsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.SmartPlug;
      reader.readMessage(value,proto.proto.SmartPlug.deserializeBinaryFromReader);
      msg.addSmartPlugs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.ListSmartPlugsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.ListSmartPlugsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.ListSmartPlugsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ListSmartPlugsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSmartPlugsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.SmartPlug.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SmartPlug smart_plugs = 1;
 * @return {!Array<!proto.proto.SmartPlug>}
 */
proto.proto.ListSmartPlugsResponse.prototype.getSmartPlugsList = function() {
  return /** @type{!Array<!proto.proto.SmartPlug>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.SmartPlug, 1));
};


/**
 * @param {!Array<!proto.proto.SmartPlug>} value
 * @return {!proto.proto.ListSmartPlugsResponse} returns this
*/
proto.proto.ListSmartPlugsResponse.prototype.setSmartPlugsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.SmartPlug=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.SmartPlug}
 */
proto.proto.ListSmartPlugsResponse.prototype.addSmartPlugs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.SmartPlug, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.ListSmartPlugsResponse} returns this
 */
proto.proto.ListSmartPlugsResponse.prototype.clearSmartPlugsList = function() {
  return this.setSmartPlugsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.TimeSeriesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.TimeSeriesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.TimeSeriesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.TimeSeriesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
smartPlugId: jspb.Message.getFieldWithDefault(msg, 1, ""),
since: jspb.Message.getFieldWithDefault(msg, 2, 0),
until: jspb.Message.getFieldWithDefault(msg, 3, 0),
targetPointsPerChart: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.TimeSeriesRequest}
 */
proto.proto.TimeSeriesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.TimeSeriesRequest;
  return proto.proto.TimeSeriesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.TimeSeriesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.TimeSeriesRequest}
 */
proto.proto.TimeSeriesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSmartPlugId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSince(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUntil(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTargetPointsPerChart(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.TimeSeriesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.TimeSeriesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.TimeSeriesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.TimeSeriesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSmartPlugId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSince();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getUntil();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getTargetPointsPerChart();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string smart_plug_id = 1;
 * @return {string}
 */
proto.proto.TimeSeriesRequest.prototype.getSmartPlugId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.TimeSeriesRequest} returns this
 */
proto.proto.TimeSeriesRequest.prototype.setSmartPlugId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 since = 2;
 * @return {number}
 */
proto.proto.TimeSeriesRequest.prototype.getSince = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.TimeSeriesRequest} returns this
 */
proto.proto.TimeSeriesRequest.prototype.setSince = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 until = 3;
 * @return {number}
 */
proto.proto.TimeSeriesRequest.prototype.getUntil = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.TimeSeriesRequest} returns this
 */
proto.proto.TimeSeriesRequest.prototype.setUntil = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 target_points_per_chart = 4;
 * @return {number}
 */
proto.proto.TimeSeriesRequest.prototype.getTargetPointsPerChart = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.TimeSeriesRequest} returns this
 */
proto.proto.TimeSeriesRequest.prototype.setTargetPointsPerChart = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.SeriesMetadata.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.SeriesMetadata.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.SeriesMetadata} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.SeriesMetadata.toObject = function(includeInstance, msg) {
  var f, obj = {
seriesName: jspb.Message.getFieldWithDefault(msg, 1, ""),
seriesMin: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
seriesMax: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
seriesAvg: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
seriesMinTime: jspb.Message.getFieldWithDefault(msg, 5, 0),
seriesMaxTime: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.SeriesMetadata}
 */
proto.proto.SeriesMetadata.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.SeriesMetadata;
  return proto.proto.SeriesMetadata.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.SeriesMetadata} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.SeriesMetadata}
 */
proto.proto.SeriesMetadata.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSeriesName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSeriesMin(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSeriesMax(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSeriesAvg(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSeriesMinTime(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSeriesMaxTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.SeriesMetadata.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.SeriesMetadata.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.SeriesMetadata} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.SeriesMetadata.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSeriesName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSeriesMin();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getSeriesMax();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getSeriesAvg();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getSeriesMinTime();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getSeriesMaxTime();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
};


/**
 * optional string series_name = 1;
 * @return {string}
 */
proto.proto.SeriesMetadata.prototype.getSeriesName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.SeriesMetadata} returns this
 */
proto.proto.SeriesMetadata.prototype.setSeriesName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double series_min = 2;
 * @return {number}
 */
proto.proto.SeriesMetadata.prototype.getSeriesMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.SeriesMetadata} returns this
 */
proto.proto.SeriesMetadata.prototype.setSeriesMin = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double series_max = 3;
 * @return {number}
 */
proto.proto.SeriesMetadata.prototype.getSeriesMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.SeriesMetadata} returns this
 */
proto.proto.SeriesMetadata.prototype.setSeriesMax = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double series_avg = 4;
 * @return {number}
 */
proto.proto.SeriesMetadata.prototype.getSeriesAvg = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.SeriesMetadata} returns this
 */
proto.proto.SeriesMetadata.prototype.setSeriesAvg = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional int64 series_min_time = 5;
 * @return {number}
 */
proto.proto.SeriesMetadata.prototype.getSeriesMinTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.SeriesMetadata} returns this
 */
proto.proto.SeriesMetadata.prototype.setSeriesMinTime = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 series_max_time = 6;
 * @return {number}
 */
proto.proto.SeriesMetadata.prototype.getSeriesMaxTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.SeriesMetadata} returns this
 */
proto.proto.SeriesMetadata.prototype.setSeriesMaxTime = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.TimeSeriesResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.TimeSeriesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.TimeSeriesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.TimeSeriesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.TimeSeriesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
metadataMap: (f = msg.getMetadataMap()) ? f.toObject(includeInstance, proto.proto.SeriesMetadata.toObject) : [],
samplesList: jspb.Message.toObjectList(msg.getSamplesList(),
    proto.proto.Sample.toObject, includeInstance),
bucketedsamples: (f = msg.getBucketedsamples()) && proto.proto.BucketedSamples.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.TimeSeriesResponse}
 */
proto.proto.TimeSeriesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.TimeSeriesResponse;
  return proto.proto.TimeSeriesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.TimeSeriesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.TimeSeriesResponse}
 */
proto.proto.TimeSeriesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getMetadataMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.proto.SeriesMetadata.deserializeBinaryFromReader, "", new proto.proto.SeriesMetadata());
         });
      break;
    case 2:
      var value = new proto.proto.Sample;
      reader.readMessage(value,proto.proto.Sample.deserializeBinaryFromReader);
      msg.addSamples(value);
      break;
    case 3:
      var value = new proto.proto.BucketedSamples;
      reader.readMessage(value,proto.proto.BucketedSamples.deserializeBinaryFromReader);
      msg.setBucketedsamples(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.TimeSeriesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.TimeSeriesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.TimeSeriesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.TimeSeriesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMetadataMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.proto.SeriesMetadata.serializeBinaryToWriter);
  }
  f = message.getSamplesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.proto.Sample.serializeBinaryToWriter
    );
  }
  f = message.getBucketedsamples();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.proto.BucketedSamples.serializeBinaryToWriter
    );
  }
};


/**
 * map<string, SeriesMetadata> metadata = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.proto.SeriesMetadata>}
 */
proto.proto.TimeSeriesResponse.prototype.getMetadataMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.proto.SeriesMetadata>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      proto.proto.SeriesMetadata));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.proto.TimeSeriesResponse} returns this
 */
proto.proto.TimeSeriesResponse.prototype.clearMetadataMap = function() {
  this.getMetadataMap().clear();
  return this;
};


/**
 * repeated Sample samples = 2;
 * @return {!Array<!proto.proto.Sample>}
 */
proto.proto.TimeSeriesResponse.prototype.getSamplesList = function() {
  return /** @type{!Array<!proto.proto.Sample>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.Sample, 2));
};


/**
 * @param {!Array<!proto.proto.Sample>} value
 * @return {!proto.proto.TimeSeriesResponse} returns this
*/
proto.proto.TimeSeriesResponse.prototype.setSamplesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.proto.Sample=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.Sample}
 */
proto.proto.TimeSeriesResponse.prototype.addSamples = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.proto.Sample, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.TimeSeriesResponse} returns this
 */
proto.proto.TimeSeriesResponse.prototype.clearSamplesList = function() {
  return this.setSamplesList([]);
};


/**
 * optional BucketedSamples bucketedSamples = 3;
 * @return {?proto.proto.BucketedSamples}
 */
proto.proto.TimeSeriesResponse.prototype.getBucketedsamples = function() {
  return /** @type{?proto.proto.BucketedSamples} */ (
    jspb.Message.getWrapperField(this, proto.proto.BucketedSamples, 3));
};


/**
 * @param {?proto.proto.BucketedSamples|undefined} value
 * @return {!proto.proto.TimeSeriesResponse} returns this
*/
proto.proto.TimeSeriesResponse.prototype.setBucketedsamples = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.TimeSeriesResponse} returns this
 */
proto.proto.TimeSeriesResponse.prototype.clearBucketedsamples = function() {
  return this.setBucketedsamples(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TimeSeriesResponse.prototype.hasBucketedsamples = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.BucketedSamples.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.BucketedSamples.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.BucketedSamples} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.BucketedSamples.toObject = function(includeInstance, msg) {
  var f, obj = {
hourlySummarySamples: (f = msg.getHourlySummarySamples()) && proto.proto.SummaryStatistics.toObject(includeInstance, f),
dailySummarySamples: (f = msg.getDailySummarySamples()) && proto.proto.SummaryStatistics.toObject(includeInstance, f),
weeklySummarySamples: (f = msg.getWeeklySummarySamples()) && proto.proto.SummaryStatistics.toObject(includeInstance, f),
monthlySummarySamples: (f = msg.getMonthlySummarySamples()) && proto.proto.SummaryStatistics.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.BucketedSamples}
 */
proto.proto.BucketedSamples.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.BucketedSamples;
  return proto.proto.BucketedSamples.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.BucketedSamples} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.BucketedSamples}
 */
proto.proto.BucketedSamples.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.SummaryStatistics;
      reader.readMessage(value,proto.proto.SummaryStatistics.deserializeBinaryFromReader);
      msg.setHourlySummarySamples(value);
      break;
    case 2:
      var value = new proto.proto.SummaryStatistics;
      reader.readMessage(value,proto.proto.SummaryStatistics.deserializeBinaryFromReader);
      msg.setDailySummarySamples(value);
      break;
    case 3:
      var value = new proto.proto.SummaryStatistics;
      reader.readMessage(value,proto.proto.SummaryStatistics.deserializeBinaryFromReader);
      msg.setWeeklySummarySamples(value);
      break;
    case 4:
      var value = new proto.proto.SummaryStatistics;
      reader.readMessage(value,proto.proto.SummaryStatistics.deserializeBinaryFromReader);
      msg.setMonthlySummarySamples(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.BucketedSamples.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.BucketedSamples.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.BucketedSamples} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.BucketedSamples.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHourlySummarySamples();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.proto.SummaryStatistics.serializeBinaryToWriter
    );
  }
  f = message.getDailySummarySamples();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.proto.SummaryStatistics.serializeBinaryToWriter
    );
  }
  f = message.getWeeklySummarySamples();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.proto.SummaryStatistics.serializeBinaryToWriter
    );
  }
  f = message.getMonthlySummarySamples();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.proto.SummaryStatistics.serializeBinaryToWriter
    );
  }
};


/**
 * optional SummaryStatistics hourly_summary_samples = 1;
 * @return {?proto.proto.SummaryStatistics}
 */
proto.proto.BucketedSamples.prototype.getHourlySummarySamples = function() {
  return /** @type{?proto.proto.SummaryStatistics} */ (
    jspb.Message.getWrapperField(this, proto.proto.SummaryStatistics, 1));
};


/**
 * @param {?proto.proto.SummaryStatistics|undefined} value
 * @return {!proto.proto.BucketedSamples} returns this
*/
proto.proto.BucketedSamples.prototype.setHourlySummarySamples = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.BucketedSamples} returns this
 */
proto.proto.BucketedSamples.prototype.clearHourlySummarySamples = function() {
  return this.setHourlySummarySamples(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.BucketedSamples.prototype.hasHourlySummarySamples = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SummaryStatistics daily_summary_samples = 2;
 * @return {?proto.proto.SummaryStatistics}
 */
proto.proto.BucketedSamples.prototype.getDailySummarySamples = function() {
  return /** @type{?proto.proto.SummaryStatistics} */ (
    jspb.Message.getWrapperField(this, proto.proto.SummaryStatistics, 2));
};


/**
 * @param {?proto.proto.SummaryStatistics|undefined} value
 * @return {!proto.proto.BucketedSamples} returns this
*/
proto.proto.BucketedSamples.prototype.setDailySummarySamples = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.BucketedSamples} returns this
 */
proto.proto.BucketedSamples.prototype.clearDailySummarySamples = function() {
  return this.setDailySummarySamples(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.BucketedSamples.prototype.hasDailySummarySamples = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional SummaryStatistics weekly_summary_samples = 3;
 * @return {?proto.proto.SummaryStatistics}
 */
proto.proto.BucketedSamples.prototype.getWeeklySummarySamples = function() {
  return /** @type{?proto.proto.SummaryStatistics} */ (
    jspb.Message.getWrapperField(this, proto.proto.SummaryStatistics, 3));
};


/**
 * @param {?proto.proto.SummaryStatistics|undefined} value
 * @return {!proto.proto.BucketedSamples} returns this
*/
proto.proto.BucketedSamples.prototype.setWeeklySummarySamples = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.BucketedSamples} returns this
 */
proto.proto.BucketedSamples.prototype.clearWeeklySummarySamples = function() {
  return this.setWeeklySummarySamples(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.BucketedSamples.prototype.hasWeeklySummarySamples = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional SummaryStatistics monthly_summary_samples = 4;
 * @return {?proto.proto.SummaryStatistics}
 */
proto.proto.BucketedSamples.prototype.getMonthlySummarySamples = function() {
  return /** @type{?proto.proto.SummaryStatistics} */ (
    jspb.Message.getWrapperField(this, proto.proto.SummaryStatistics, 4));
};


/**
 * @param {?proto.proto.SummaryStatistics|undefined} value
 * @return {!proto.proto.BucketedSamples} returns this
*/
proto.proto.BucketedSamples.prototype.setMonthlySummarySamples = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.BucketedSamples} returns this
 */
proto.proto.BucketedSamples.prototype.clearMonthlySummarySamples = function() {
  return this.setMonthlySummarySamples(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.BucketedSamples.prototype.hasMonthlySummarySamples = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.DisplayNameRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.DisplayNameRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.DisplayNameRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.DisplayNameRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
smartPlugId: jspb.Message.getFieldWithDefault(msg, 1, ""),
displayName: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.DisplayNameRequest}
 */
proto.proto.DisplayNameRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.DisplayNameRequest;
  return proto.proto.DisplayNameRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.DisplayNameRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.DisplayNameRequest}
 */
proto.proto.DisplayNameRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSmartPlugId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.DisplayNameRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.DisplayNameRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.DisplayNameRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.DisplayNameRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSmartPlugId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string smart_plug_id = 1;
 * @return {string}
 */
proto.proto.DisplayNameRequest.prototype.getSmartPlugId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.DisplayNameRequest} returns this
 */
proto.proto.DisplayNameRequest.prototype.setSmartPlugId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string display_name = 2;
 * @return {string}
 */
proto.proto.DisplayNameRequest.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.DisplayNameRequest} returns this
 */
proto.proto.DisplayNameRequest.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.DisplayNameResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.DisplayNameResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.DisplayNameResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.DisplayNameResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
successful: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.DisplayNameResponse}
 */
proto.proto.DisplayNameResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.DisplayNameResponse;
  return proto.proto.DisplayNameResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.DisplayNameResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.DisplayNameResponse}
 */
proto.proto.DisplayNameResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccessful(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.DisplayNameResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.DisplayNameResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.DisplayNameResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.DisplayNameResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccessful();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional bool successful = 1;
 * @return {boolean}
 */
proto.proto.DisplayNameResponse.prototype.getSuccessful = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.DisplayNameResponse} returns this
 */
proto.proto.DisplayNameResponse.prototype.setSuccessful = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.proto.DisplayNameResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.DisplayNameResponse} returns this
 */
proto.proto.DisplayNameResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.SummaryStatisticsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.SummaryStatisticsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.SummaryStatisticsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.SummaryStatisticsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
smartPlugId: jspb.Message.getFieldWithDefault(msg, 1, ""),
since: jspb.Message.getFieldWithDefault(msg, 2, 0),
until: jspb.Message.getFieldWithDefault(msg, 3, 0),
bucketIntervalMillis: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.SummaryStatisticsRequest}
 */
proto.proto.SummaryStatisticsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.SummaryStatisticsRequest;
  return proto.proto.SummaryStatisticsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.SummaryStatisticsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.SummaryStatisticsRequest}
 */
proto.proto.SummaryStatisticsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSmartPlugId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSince(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUntil(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBucketIntervalMillis(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.SummaryStatisticsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.SummaryStatisticsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.SummaryStatisticsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.SummaryStatisticsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSmartPlugId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSince();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getUntil();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getBucketIntervalMillis();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional string smart_plug_id = 1;
 * @return {string}
 */
proto.proto.SummaryStatisticsRequest.prototype.getSmartPlugId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.SummaryStatisticsRequest} returns this
 */
proto.proto.SummaryStatisticsRequest.prototype.setSmartPlugId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 since = 2;
 * @return {number}
 */
proto.proto.SummaryStatisticsRequest.prototype.getSince = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.SummaryStatisticsRequest} returns this
 */
proto.proto.SummaryStatisticsRequest.prototype.setSince = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 until = 3;
 * @return {number}
 */
proto.proto.SummaryStatisticsRequest.prototype.getUntil = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.SummaryStatisticsRequest} returns this
 */
proto.proto.SummaryStatisticsRequest.prototype.setUntil = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 bucket_interval_millis = 4;
 * @return {number}
 */
proto.proto.SummaryStatisticsRequest.prototype.getBucketIntervalMillis = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.SummaryStatisticsRequest} returns this
 */
proto.proto.SummaryStatisticsRequest.prototype.setBucketIntervalMillis = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.SummaryStatisticsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.SummaryStatisticsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.SummaryStatisticsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.SummaryStatisticsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
bucketIntervalMillis: jspb.Message.getFieldWithDefault(msg, 1, 0),
statistics: (f = msg.getStatistics()) && proto.proto.SummaryStatistics.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.SummaryStatisticsResponse}
 */
proto.proto.SummaryStatisticsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.SummaryStatisticsResponse;
  return proto.proto.SummaryStatisticsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.SummaryStatisticsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.SummaryStatisticsResponse}
 */
proto.proto.SummaryStatisticsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBucketIntervalMillis(value);
      break;
    case 2:
      var value = new proto.proto.SummaryStatistics;
      reader.readMessage(value,proto.proto.SummaryStatistics.deserializeBinaryFromReader);
      msg.setStatistics(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.SummaryStatisticsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.SummaryStatisticsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.SummaryStatisticsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.SummaryStatisticsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBucketIntervalMillis();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getStatistics();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.proto.SummaryStatistics.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 bucket_interval_millis = 1;
 * @return {number}
 */
proto.proto.SummaryStatisticsResponse.prototype.getBucketIntervalMillis = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.SummaryStatisticsResponse} returns this
 */
proto.proto.SummaryStatisticsResponse.prototype.setBucketIntervalMillis = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional SummaryStatistics statistics = 2;
 * @return {?proto.proto.SummaryStatistics}
 */
proto.proto.SummaryStatisticsResponse.prototype.getStatistics = function() {
  return /** @type{?proto.proto.SummaryStatistics} */ (
    jspb.Message.getWrapperField(this, proto.proto.SummaryStatistics, 2));
};


/**
 * @param {?proto.proto.SummaryStatistics|undefined} value
 * @return {!proto.proto.SummaryStatisticsResponse} returns this
*/
proto.proto.SummaryStatisticsResponse.prototype.setStatistics = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.SummaryStatisticsResponse} returns this
 */
proto.proto.SummaryStatisticsResponse.prototype.clearStatistics = function() {
  return this.setStatistics(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.SummaryStatisticsResponse.prototype.hasStatistics = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.SummaryStatistics.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.SummaryStatistics.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.SummaryStatistics.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.SummaryStatistics} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.SummaryStatistics.toObject = function(includeInstance, msg) {
  var f, obj = {
metadataMap: (f = msg.getMetadataMap()) ? f.toObject(includeInstance, proto.proto.SeriesMetadata.toObject) : [],
summarySamplesList: jspb.Message.toObjectList(msg.getSummarySamplesList(),
    proto.proto.SummarySample.toObject, includeInstance),
lastVolts: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
lastAmps: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
latestTrend: (f = msg.getLatestTrend()) && proto.proto.Trend.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.SummaryStatistics}
 */
proto.proto.SummaryStatistics.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.SummaryStatistics;
  return proto.proto.SummaryStatistics.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.SummaryStatistics} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.SummaryStatistics}
 */
proto.proto.SummaryStatistics.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getMetadataMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.proto.SeriesMetadata.deserializeBinaryFromReader, "", new proto.proto.SeriesMetadata());
         });
      break;
    case 2:
      var value = new proto.proto.SummarySample;
      reader.readMessage(value,proto.proto.SummarySample.deserializeBinaryFromReader);
      msg.addSummarySamples(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLastVolts(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLastAmps(value);
      break;
    case 5:
      var value = new proto.proto.Trend;
      reader.readMessage(value,proto.proto.Trend.deserializeBinaryFromReader);
      msg.setLatestTrend(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.SummaryStatistics.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.SummaryStatistics.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.SummaryStatistics} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.SummaryStatistics.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMetadataMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.proto.SeriesMetadata.serializeBinaryToWriter);
  }
  f = message.getSummarySamplesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.proto.SummarySample.serializeBinaryToWriter
    );
  }
  f = message.getLastVolts();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getLastAmps();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getLatestTrend();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.proto.Trend.serializeBinaryToWriter
    );
  }
};


/**
 * map<string, SeriesMetadata> metadata = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.proto.SeriesMetadata>}
 */
proto.proto.SummaryStatistics.prototype.getMetadataMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.proto.SeriesMetadata>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      proto.proto.SeriesMetadata));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.proto.SummaryStatistics} returns this
 */
proto.proto.SummaryStatistics.prototype.clearMetadataMap = function() {
  this.getMetadataMap().clear();
  return this;
};


/**
 * repeated SummarySample summary_samples = 2;
 * @return {!Array<!proto.proto.SummarySample>}
 */
proto.proto.SummaryStatistics.prototype.getSummarySamplesList = function() {
  return /** @type{!Array<!proto.proto.SummarySample>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.SummarySample, 2));
};


/**
 * @param {!Array<!proto.proto.SummarySample>} value
 * @return {!proto.proto.SummaryStatistics} returns this
*/
proto.proto.SummaryStatistics.prototype.setSummarySamplesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.proto.SummarySample=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.SummarySample}
 */
proto.proto.SummaryStatistics.prototype.addSummarySamples = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.proto.SummarySample, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.SummaryStatistics} returns this
 */
proto.proto.SummaryStatistics.prototype.clearSummarySamplesList = function() {
  return this.setSummarySamplesList([]);
};


/**
 * optional double last_volts = 3;
 * @return {number}
 */
proto.proto.SummaryStatistics.prototype.getLastVolts = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.SummaryStatistics} returns this
 */
proto.proto.SummaryStatistics.prototype.setLastVolts = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double last_amps = 4;
 * @return {number}
 */
proto.proto.SummaryStatistics.prototype.getLastAmps = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.SummaryStatistics} returns this
 */
proto.proto.SummaryStatistics.prototype.setLastAmps = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional Trend latest_trend = 5;
 * @return {?proto.proto.Trend}
 */
proto.proto.SummaryStatistics.prototype.getLatestTrend = function() {
  return /** @type{?proto.proto.Trend} */ (
    jspb.Message.getWrapperField(this, proto.proto.Trend, 5));
};


/**
 * @param {?proto.proto.Trend|undefined} value
 * @return {!proto.proto.SummaryStatistics} returns this
*/
proto.proto.SummaryStatistics.prototype.setLatestTrend = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.SummaryStatistics} returns this
 */
proto.proto.SummaryStatistics.prototype.clearLatestTrend = function() {
  return this.setLatestTrend(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.SummaryStatistics.prototype.hasLatestTrend = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Trend.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Trend.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Trend} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Trend.toObject = function(includeInstance, msg) {
  var f, obj = {
trendDescription: jspb.Message.getFieldWithDefault(msg, 1, ""),
intervalName: jspb.Message.getFieldWithDefault(msg, 2, ""),
percentChange: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Trend}
 */
proto.proto.Trend.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Trend;
  return proto.proto.Trend.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Trend} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Trend}
 */
proto.proto.Trend.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTrendDescription(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setIntervalName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPercentChange(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Trend.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Trend.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Trend} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Trend.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTrendDescription();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIntervalName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPercentChange();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
};


/**
 * optional string trend_description = 1;
 * @return {string}
 */
proto.proto.Trend.prototype.getTrendDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Trend} returns this
 */
proto.proto.Trend.prototype.setTrendDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string interval_name = 2;
 * @return {string}
 */
proto.proto.Trend.prototype.getIntervalName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Trend} returns this
 */
proto.proto.Trend.prototype.setIntervalName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional double percent_change = 3;
 * @return {number}
 */
proto.proto.Trend.prototype.getPercentChange = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Trend} returns this
 */
proto.proto.Trend.prototype.setPercentChange = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.SummarySample.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.SummarySample.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.SummarySample} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.SummarySample.toObject = function(includeInstance, msg) {
  var f, obj = {
time: jspb.Message.getFieldWithDefault(msg, 1, 0),
totalWatts: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
totalCents: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.SummarySample}
 */
proto.proto.SummarySample.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.SummarySample;
  return proto.proto.SummarySample.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.SummarySample} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.SummarySample}
 */
proto.proto.SummarySample.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTime(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalWatts(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalCents(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.SummarySample.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.SummarySample.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.SummarySample} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.SummarySample.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTime();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTotalWatts();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getTotalCents();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
};


/**
 * optional int64 time = 1;
 * @return {number}
 */
proto.proto.SummarySample.prototype.getTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.SummarySample} returns this
 */
proto.proto.SummarySample.prototype.setTime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional double total_watts = 2;
 * @return {number}
 */
proto.proto.SummarySample.prototype.getTotalWatts = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.SummarySample} returns this
 */
proto.proto.SummarySample.prototype.setTotalWatts = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double total_cents = 3;
 * @return {number}
 */
proto.proto.SummarySample.prototype.getTotalCents = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.SummarySample} returns this
 */
proto.proto.SummarySample.prototype.setTotalCents = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.AggregateStatisticsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.AggregateStatisticsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.AggregateStatisticsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.AggregateStatisticsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
filter: jspb.Message.getFieldWithDefault(msg, 1, ""),
since: jspb.Message.getFieldWithDefault(msg, 2, 0),
until: jspb.Message.getFieldWithDefault(msg, 3, 0),
bucketIntervalMillis: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.AggregateStatisticsRequest}
 */
proto.proto.AggregateStatisticsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.AggregateStatisticsRequest;
  return proto.proto.AggregateStatisticsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.AggregateStatisticsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.AggregateStatisticsRequest}
 */
proto.proto.AggregateStatisticsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilter(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSince(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUntil(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBucketIntervalMillis(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.AggregateStatisticsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.AggregateStatisticsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.AggregateStatisticsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.AggregateStatisticsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFilter();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSince();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getUntil();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getBucketIntervalMillis();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional string filter = 1;
 * @return {string}
 */
proto.proto.AggregateStatisticsRequest.prototype.getFilter = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.AggregateStatisticsRequest} returns this
 */
proto.proto.AggregateStatisticsRequest.prototype.setFilter = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 since = 2;
 * @return {number}
 */
proto.proto.AggregateStatisticsRequest.prototype.getSince = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.AggregateStatisticsRequest} returns this
 */
proto.proto.AggregateStatisticsRequest.prototype.setSince = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 until = 3;
 * @return {number}
 */
proto.proto.AggregateStatisticsRequest.prototype.getUntil = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.AggregateStatisticsRequest} returns this
 */
proto.proto.AggregateStatisticsRequest.prototype.setUntil = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 bucket_interval_millis = 4;
 * @return {number}
 */
proto.proto.AggregateStatisticsRequest.prototype.getBucketIntervalMillis = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.AggregateStatisticsRequest} returns this
 */
proto.proto.AggregateStatisticsRequest.prototype.setBucketIntervalMillis = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.AggregateStatisticsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.AggregateStatisticsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.AggregateStatisticsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.AggregateStatisticsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
bucketIntervalMillis: jspb.Message.getFieldWithDefault(msg, 1, 0),
statistics: (f = msg.getStatistics()) && proto.proto.SummaryStatistics.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.AggregateStatisticsResponse}
 */
proto.proto.AggregateStatisticsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.AggregateStatisticsResponse;
  return proto.proto.AggregateStatisticsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.AggregateStatisticsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.AggregateStatisticsResponse}
 */
proto.proto.AggregateStatisticsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBucketIntervalMillis(value);
      break;
    case 2:
      var value = new proto.proto.SummaryStatistics;
      reader.readMessage(value,proto.proto.SummaryStatistics.deserializeBinaryFromReader);
      msg.setStatistics(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.AggregateStatisticsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.AggregateStatisticsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.AggregateStatisticsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.AggregateStatisticsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBucketIntervalMillis();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getStatistics();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.proto.SummaryStatistics.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 bucket_interval_millis = 1;
 * @return {number}
 */
proto.proto.AggregateStatisticsResponse.prototype.getBucketIntervalMillis = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.AggregateStatisticsResponse} returns this
 */
proto.proto.AggregateStatisticsResponse.prototype.setBucketIntervalMillis = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional SummaryStatistics statistics = 2;
 * @return {?proto.proto.SummaryStatistics}
 */
proto.proto.AggregateStatisticsResponse.prototype.getStatistics = function() {
  return /** @type{?proto.proto.SummaryStatistics} */ (
    jspb.Message.getWrapperField(this, proto.proto.SummaryStatistics, 2));
};


/**
 * @param {?proto.proto.SummaryStatistics|undefined} value
 * @return {!proto.proto.AggregateStatisticsResponse} returns this
*/
proto.proto.AggregateStatisticsResponse.prototype.setStatistics = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.AggregateStatisticsResponse} returns this
 */
proto.proto.AggregateStatisticsResponse.prototype.clearStatistics = function() {
  return this.setStatistics(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.AggregateStatisticsResponse.prototype.hasStatistics = function() {
  return jspb.Message.getField(this, 2) != null;
};


goog.object.extend(exports, proto.proto);
